import React from "react";
import $ from "$";
import { Row, Col, Button, message } from "antd";
import isEmpty from "lodash/isEmpty";
import toString from "lodash/toString";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import WeaTools from "../../wea-tools";
import WeaAssociativeSearch from "../../base/wea-associative-search";
import WeaNewScroll from "../../wea-new-scroll";
import WeaLocaleProvider from "../../wea-locale-provider";
import WeaDialog from "../../wea-dialog";
import WeaButtonIcon from "../../wea-button-icon";
import WeaTab from "../../wea-tab";
import WeaTableEditable from "../../wea-table-editable";

const getLabel = WeaLocaleProvider.getLabel;

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      name: "",
      url: props.dataUrl,
      isClearData: false,
      visible: false,
      headerId: "all",
      datas: [],
      panelStyle: {},
      selectedKey: 0,
      browserType: [],
      detailType: [],
      selectType: [],
      selectedKeys: [],
      saving: false
    };
    // 默认显示数据
    if (!isEmpty(this.props.replaceDatas) && this.props.replaceDatas[0]) {
      this.state.id = toString(this.props.replaceDatas[0].id);
      this.state.name = this.props.replaceDatas[0].name;
    }

    this.selectedSearch = this.selectedSearch.bind(this);
    this.props.initFunc && this.props.initFunc(this);
  }

  // 和其它浏览按钮保持行为一直的暴露方法
  openModal() {
    this.setState({ visible: true }, () => {
      this.setPosition();
    });
  }
  // 和其它浏览按钮保持行为一直的暴露方法
  closeModal() {
    this.setState({ visible: false, panelStyle: {} });
  }
  setPosition() {
    const pos = $(this.refs.wrapper)[0].getBoundingClientRect();
    const dom = WeaTools.WindowFunc.getTop().document;
    const panelStyle = { opacity: 1, left: pos.left };
    let top = pos.top + 35;
    const maxHeight = dom.body.clientHeight;
    const panelHeight = this.refs.panel ? this.refs.panel.clientHeight : 260;
    if (top > maxHeight - panelHeight) top = pos.top - panelHeight - 10;
    if (top < 0) {
      top = 0;
    }
    panelStyle.top = top;
    if (pos.left + 500 > dom.documentElement.clientWidth) {
      panelStyle.width = dom.documentElement.clientWidth - pos.left;
    }
    this.setState({ panelStyle });
  }
  componentDidMount() {
    const { dataURL } = this.props;
    WeaTools.callApi(dataURL).then(data => {
      this.setState({ datas: data.groups });
    });
  }
  componentWillReceiveProps(nextProps) {
    if ("value" in nextProps && this.state.id !== nextProps.value) {
      this.setState({ id: nextProps.value });
    }
    if ("valueSpan" in nextProps && this.state.name !== nextProps.valueSpan) {
      this.setState({ id: nextProps.valueSpan });
    }
    if (
      "replaceDatas" in nextProps &&
      !isEqual(this.props.replaceDatas, nextProps.replaceDatas)
    ) {
      let id = "";
      let name = "";
      if (!isEmpty(nextProps.replaceDatas) && nextProps.replaceDatas[0]) {
        name = nextProps.replaceDatas[0].name;
        id = toString(nextProps.replaceDatas[0].id);
      }
      this.setState({ id, name });
    }
  }
  selectedSearch(id, name, data) {
    this.setState({ id, name });
    this.throwCurrentState(id, name, data);
  }
  throwCurrentState(id = "", name, record) {
    const data = [];
    if (id || name) {
      data.push({
        id: id.toString(),
        name
      });
    }
    this.props.onChange &&
      this.props.onChange(id.toString(), name, record || data);
  }
  onHeaderClick(id) {
    const { headerId } = this.state;
    if (headerId !== id) {
      this.setState({ headerId: id });
      this.refs.scroll.scroll(0);
    }
  }
  onClick(id, name) {
    this.setState({ id, name, visible: false, panelStyle: {} });
    this.throwCurrentState(id, name);
  }
  showSettingPanel = () => {
    WeaTools.callApi("/api/common/browserType/getBrowerTypeDetailType")
      .then(res => {
        const { hasRight } = res;
        if (hasRight) {
          const { datas, types } = res;
          this.setState({
            visibleSetting: true,
            detailType: datas || [],
            selectType: types || []
          });
          return WeaTools.callApi("/api/common/browserType/getBrowserType");
        }
        return null;
      })
      .then(res => {
        if (res && res.datas) {
          this.setState({ browserType: res.datas || [] });
        } else {
          // 无权限
        }
      });
  };
  onSave = () => {
    const { selectedKey, browserType, detailType } = this.state;
    const cb = res => {
      const { api_status, msg } = res;
      if (api_status) {
        WeaTools.callApi(this.props.dataURL).then(data => {
          this.setState({
            datas: data.groups,
            visibleSetting: false,
            saving: false,
            detailType: [],
            selectType: [],
            selectedKey: 0
          });
          message.success(msg);
        });
      } else {
        message.error(msg);
      }
    };
    if (selectedKey == 1) {
      const result = this.refs.tableEditable.doValidate();
      if (result.pass) {
        this.setState({ saving: true });
        WeaTools.callApi("/api/common/browserType/updateBrowserType", "POST", {
          datas: JSON.stringify(browserType)
        }).then(cb);
      }
    } else {
      this.setState({ saving: true });
      WeaTools.callApi(
        "/api/common/browserType/updateBrowerTypeDetail",
        "POST",
        { datas: JSON.stringify(detailType) }
      ).then(cb);
    }
  };
  renderAsssosiate() {
    const { type } = this.props;
    const { id, name, visible } = this.state;
    return (
      <WeaAssociativeSearch
        {...this.props}
        isCity
        style={this.props.inputStyle}
        type={type}
        ids={id}
        names={name}
        modalVisable={visible}
        clickCallback={() => {
          const newVisible = !this.state.visible;
          this.setState(
            { visible: newVisible, panelStyle: {}, headerId: "all" },
            () => {
              newVisible && this.setPosition();
            }
          );
        }}
        onChange={this.selectedSearch}
      />
    );
  }
  renderPanel() {
    const { datas, headerId, id, panelStyle, visibleSetting } = this.state;
    let listDatas = cloneDeep(datas);
    if (headerId !== "all" && !isEmpty(listDatas)) {
      listDatas = listDatas.filter(item => item.groupid === headerId);
    }
    return (
      <div
        className={`wea-type-list-panel wdb ${
          visibleSetting ? "showDialog" : ""
        }`}
        style={panelStyle}
        ref="panel"
      >
        <i
          className="cursor-pointer icon-coms-Flow-setting"
          onClick={this.showSettingPanel}
        />
        <div className="wea-type-list-header">
          <span
            className={`cursor-pointer list-item ${
              headerId === "all" ? "active" : ""
            }`}
            onClick={() => this.onHeaderClick("all")}
          >
            {getLabel("21979", "全部类型")}
          </span>
          {datas &&
            datas.map(item => (
              <span
                className={`cursor-pointer list-item ${
                  headerId === item.groupid ? "active" : ""
                }`}
                onClick={() => this.onHeaderClick(item.groupid)}
              >
                {item.groupname}
              </span>
            ))}
        </div>
        <WeaNewScroll
          className="wea-type-list-content"
          height={200}
          ref="scroll"
        >
          {listDatas &&
            listDatas.map(item => (
              <Row className="wea-type-list-content-item">
                <Col className="wea-type-list-content-item-left" span={4}>
                  {item.groupname}
                </Col>
                <Col span={20}>
                  {item.items &&
                    item.items.map((im, idx) => (
                      <span>
                        <span
                          className={`cursor-pointer list-item ${
                            id === im.key ? "active" : ""
                          }`}
                          onClick={() => this.onClick(im.key, im.value)}
                        >
                          {im.value}
                        </span>
                        {item.items.length - 1 !== idx && (
                          <span className="splite">|</span>
                        )}
                      </span>
                    ))}
                </Col>
              </Row>
            ))}
        </WeaNewScroll>
      </div>
    );
  }
  render() {
    const {
      visible,
      visibleSetting,
      selectedKey,
      detailType,
      selectType,
      browserType,
      selectedKeys,
      saving
    } = this.state;
    const { mask, hideSearch = false } = this.props;
    const columns =
      selectedKey == 1
        ? [
            {
              title: getLabel("33439", "名称"),
              dataIndex: "labelName",
              key: "labelName",
              com: [
                {
                  type: "INPUT",
                  style: { width: 200 },
                  key: "labelName",
                  viewAttr: 3,
                  isBase64: true,
                  inputType: "multilang",
                  maxLength: 20
                }
              ],
              width: "65%"
            },
            {
              title: getLabel("18096", "禁用"),
              dataIndex: "useable",
              // 显示全选
              showCheckAll: true,
              width: "20%",
              // 自定义值类型
              com: [{ type: "CHECKBOX", key: "useable" }]
            }
          ]
        : [
            {
              title: getLabel("505266", "浏览类型名称"),
              dataIndex: "labelName",
              width: "40%",
              com: [
                {
                  type: "INPUT",
                  key: "labelName",
                  viewAttr: 1
                }
              ]
            },
            {
              title: getLabel("455", "分类"),
              dataIndex: "typeId",
              width: "40%",
              com: [
                {
                  type: "SELECT",
                  key: "typeId",
                  style: { width: 200 },
                  options: selectType
                }
              ]
            },
            {
              title: getLabel("18096", "禁用"),
              dataIndex: "useable",
              // 显示全选
              showCheckAll: true,
              width: "20%",
              // 自定义值类型
              com: [{ type: "CHECKBOX", key: "useable" }]
            }
          ];
    const datas = selectedKey == 1 ? browserType : detailType;
    const tabs = [
      {
        title: getLabel("16490", "分类设置"),
        viewcondition: 0
      },
      {
        title: getLabel("16493", "类别设置"),
        viewcondition: 1
      }
    ];
    const tabBtns =
      selectedKey == 1
        ? [
            <WeaButtonIcon
              buttonType="add"
              type="primary"
              onClick={() => this.refs.tableEditable.doAdd()}
            />,
            <WeaButtonIcon
              buttonType="del"
              type="primary"
              onClick={() => this.refs.tableEditable.doDelete()}
              disabled={selectedKeys.length == 0}
            />
          ]
        : [];
    return (
      <div className="wea-type-list" ref="wrapper">
        {!hideSearch && this.renderAsssosiate()}
        {visible && this.renderPanel()}
        {mask && (
          <div
            className="wea-mask-dark"
            style={{ display: visible ? "block" : "none", position: "fixed" }}
            onClick={() => this.setState({ visible: false })}
          />
        )}
        <WeaDialog
          title={getLabel("16493", "类别设置")}
          visible={visibleSetting}
          buttons={[
            <Button
              type="primary"
              onClick={this.onSave}
              loading={saving}
              disabled={saving}
            >
              {getLabel("30986", "保存")}
            </Button>
          ]}
          onCancel={() => this.setState({ visibleSetting: false })}
          style={{ width: 800, height: 600 }}
        >
          <WeaTab
            datas={tabs}
            buttons={tabBtns}
            keyParam="viewcondition" // 主键
            selectedKey={selectedKey}
            onChange={v => this.setState({ selectedKey: v })}
          />
          <WeaTableEditable
            ref="tableEditable"
            draggable={selectedKey == 1}
            columns={columns}
            datas={datas}
            deleteConfirm={true}
            showTitle={false}
            tableProps={{ scroll: { y: 600 - 47 - 48 } }}
            validator={
              selectedKey == 1
                ? {
                    rules: {
                      labelName: "required"
                    }
                  }
                : {}
            }
            onChange={e => {
              e = e.map((data, i) => {
                let d = {
                  ...data,
                  labelName: data.labelName || "",
                  useable: data.useable || "0"
                };
                if (selectedKey == 1) {
                  d = {
                    ...d,
                    orderid: i + 1,
                    changeable: d.changeable || "1"
                  };
                }
                return d;
              });
              let newState = {};
              if (selectedKey == 1) {
                newState = { ...newState, browserType: e };
              } else {
                newState = { ...newState, detailType: e };
              }
              this.setState(newState);
            }}
            onRowSelect={e => this.setState({ selectedKeys: e })}
            getRowSelection={
              selectedKey == 1
                ? rowSelection => {
                    const sel = { ...rowSelection };
                    sel.getCheckboxProps = record => ({
                      disabled: record.changeable == 0
                    });
                    return sel;
                  }
                : () => {}
            }
          />
        </WeaDialog>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./ecology9/wea-browser/coms/WeaTypeList.js